import React, { useMemo } from 'react';
import { TaskCategory } from '@sib/api';
import { TaskCategorySelectItem } from '@sib/ui';

export const useTaskCategoryOptions = () =>
  useMemo(
    () => [
      {
        label: <TaskCategorySelectItem label={TaskCategory.Other} />,
        value: TaskCategory.Other,
        hidden: true,
      },
      ...Object.values(TaskCategory)
        .filter(item => item !== TaskCategory.Other)
        .map(option => ({
          label: <TaskCategorySelectItem label={option} />,
          value: option,
        })),
    ],
    []
  );
